import { GrowthDataSet } from '../../types/data-set.types';

export const whoGirlsBmiMonthly: GrowthDataSet = {
  id: 'who-girls-bmi-monthly-0-5',
  source: 'WHO',
  title: 'BMI-for-age',
  intervalType: 'month',
  gender: 'female',
  measurementType: 'bmi',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'kg/m²',
  dataPoints: [
    {
      age: 0,
      m: 13.3363,
      s: 0.09272,
      percentiles: {
        p1: 10.8,
        p3: 11.2,
        p5: 11.5,
        p15: 12.1,
        p25: 12.5,
        p50: 13.3,
        p75: 14.2,
        p85: 14.7,
        p95: 15.5,
        p97: 15.9,
        p99: 16.6,
      },
    },
    {
      age: 1,
      m: 14.5679,
      s: 0.09556,
      percentiles: {
        p1: 11.6,
        p3: 12.1,
        p5: 12.4,
        p15: 13.2,
        p25: 13.6,
        p50: 14.6,
        p75: 15.5,
        p85: 16.1,
        p95: 17.0,
        p97: 17.3,
        p99: 18.0,
      },
    },
    {
      age: 2,
      m: 15.7679,
      s: 0.09371,
      percentiles: {
        p1: 12.6,
        p3: 13.2,
        p5: 13.5,
        p15: 14.3,
        p25: 14.8,
        p50: 15.8,
        p75: 16.8,
        p85: 17.4,
        p95: 18.4,
        p97: 18.8,
        p99: 19.5,
      },
    },
    {
      age: 3,
      m: 16.3574,
      s: 0.09254,
      percentiles: {
        p1: 13.2,
        p3: 13.7,
        p5: 14.0,
        p15: 14.9,
        p25: 15.4,
        p50: 16.4,
        p75: 17.4,
        p85: 18.0,
        p95: 19.0,
        p97: 19.4,
        p99: 20.3,
      },
    },
    {
      age: 4,
      m: 16.6703,
      s: 0.09166,
      percentiles: {
        p1: 13.5,
        p3: 14.0,
        p5: 14.3,
        p15: 15.2,
        p25: 15.7,
        p50: 16.7,
        p75: 17.7,
        p85: 18.3,
        p95: 19.4,
        p97: 19.8,
        p99: 20.6,
      },
    },
    {
      age: 5,
      m: 16.8386,
      s: 0.09096,
      percentiles: {
        p1: 13.7,
        p3: 14.2,
        p5: 14.5,
        p15: 15.3,
        p25: 15.8,
        p50: 16.8,
        p75: 17.9,
        p85: 18.5,
        p95: 19.6,
        p97: 20.0,
        p99: 20.8,
      },
    },
    {
      age: 6,
      m: 16.9083,
      s: 0.09036,
      percentiles: {
        p1: 13.7,
        p3: 14.3,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.9,
        p75: 18.0,
        p85: 18.6,
        p95: 19.6,
        p97: 20.1,
        p99: 20.9,
      },
    },
    {
      age: 7,
      m: 16.902,
      s: 0.08984,
      percentiles: {
        p1: 13.8,
        p3: 14.3,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.9,
        p75: 18.0,
        p85: 18.6,
        p95: 19.6,
        p97: 20.1,
        p99: 20.9,
      },
    },
    {
      age: 8,
      m: 16.8404,
      s: 0.08939,
      percentiles: {
        p1: 13.7,
        p3: 14.3,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.8,
        p75: 17.9,
        p85: 18.5,
        p95: 19.6,
        p97: 20.0,
        p99: 20.8,
      },
    },
    {
      age: 9,
      m: 16.7406,
      s: 0.08898,
      percentiles: {
        p1: 13.7,
        p3: 14.2,
        p5: 14.5,
        p15: 15.3,
        p25: 15.8,
        p50: 16.7,
        p75: 17.8,
        p85: 18.4,
        p95: 19.4,
        p97: 19.9,
        p99: 20.7,
      },
    },
    {
      age: 10,
      m: 16.6184,
      s: 0.08861,
      percentiles: {
        p1: 13.6,
        p3: 14.1,
        p5: 14.4,
        p15: 15.2,
        p25: 15.7,
        p50: 16.6,
        p75: 17.7,
        p85: 18.2,
        p95: 19.3,
        p97: 19.7,
        p99: 20.6,
      },
    },
    {
      age: 11,
      m: 16.4875,
      s: 0.08828,
      percentiles: {
        p1: 13.5,
        p3: 14.0,
        p5: 14.3,
        p15: 15.1,
        p25: 15.5,
        p50: 16.5,
        p75: 17.5,
        p85: 18.1,
        p95: 19.1,
        p97: 19.6,
        p99: 20.4,
      },
    },
    {
      age: 12,
      m: 16.3568,
      s: 0.08797,
      percentiles: {
        p1: 13.4,
        p3: 13.9,
        p5: 14.2,
        p15: 15.0,
        p25: 15.4,
        p50: 16.4,
        p75: 17.4,
        p85: 17.9,
        p95: 19.0,
        p97: 19.4,
        p99: 20.2,
      },
    },
    {
      age: 13,
      m: 16.2311,
      s: 0.08768,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.1,
        p15: 14.8,
        p25: 15.3,
        p50: 16.2,
        p75: 17.2,
        p85: 17.8,
        p95: 18.8,
        p97: 19.2,
        p99: 20.1,
      },
    },
    {
      age: 14,
      m: 16.1128,
      s: 0.08741,
      percentiles: {
        p1: 13.3,
        p3: 13.7,
        p5: 14.0,
        p15: 14.7,
        p25: 15.2,
        p50: 16.1,
        p75: 17.1,
        p85: 17.7,
        p95: 18.7,
        p97: 19.1,
        p99: 19.9,
      },
    },
    {
      age: 15,
      m: 16.0028,
      s: 0.08716,
      percentiles: {
        p1: 13.2,
        p3: 13.7,
        p5: 13.9,
        p15: 14.6,
        p25: 15.1,
        p50: 16.0,
        p75: 17.0,
        p85: 17.5,
        p95: 18.6,
        p97: 19.0,
        p99: 19.8,
      },
    },
    {
      age: 16,
      m: 15.9017,
      s: 0.08693,
      percentiles: {
        p1: 13.1,
        p3: 13.6,
        p5: 13.8,
        p15: 14.6,
        p25: 15.0,
        p50: 15.9,
        p75: 16.9,
        p85: 17.4,
        p95: 18.4,
        p97: 18.8,
        p99: 19.7,
      },
    },
    {
      age: 17,
      m: 15.8096,
      s: 0.08671,
      percentiles: {
        p1: 13.0,
        p3: 13.5,
        p5: 13.8,
        p15: 14.5,
        p25: 14.9,
        p50: 15.8,
        p75: 16.8,
        p85: 17.3,
        p95: 18.3,
        p97: 18.7,
        p99: 19.5,
      },
    },
    {
      age: 18,
      m: 15.7263,
      s: 0.0865,
      percentiles: {
        p1: 13.0,
        p3: 13.4,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.7,
        p75: 16.7,
        p85: 17.2,
        p95: 18.2,
        p97: 18.6,
        p99: 19.4,
      },
    },
    {
      age: 19,
      m: 15.6517,
      s: 0.0863,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.8,
        p50: 15.7,
        p75: 16.6,
        p85: 17.2,
        p95: 18.1,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      age: 20,
      m: 15.5855,
      s: 0.08612,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.6,
        p75: 16.5,
        p85: 17.1,
        p95: 18.1,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      age: 21,
      m: 15.5278,
      s: 0.08594,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.6,
        p15: 14.2,
        p25: 14.7,
        p50: 15.5,
        p75: 16.5,
        p85: 17.0,
        p95: 18.0,
        p97: 18.4,
        p99: 19.2,
      },
    },
    {
      age: 22,
      m: 15.4787,
      s: 0.08577,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.5,
        p75: 16.4,
        p85: 17.0,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 23,
      m: 15.438,
      s: 0.0856,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.4,
        p85: 16.9,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 24,
      m: 15.4052,
      s: 0.08545,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.9,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 25,
      m: 15.659,
      s: 0.08452,
      percentiles: {
        p1: 13.0,
        p3: 13.4,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.7,
        p75: 16.6,
        p85: 17.1,
        p95: 18.1,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      age: 26,
      m: 15.6308,
      s: 0.08449,
      percentiles: {
        p1: 13.0,
        p3: 13.4,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.6,
        p75: 16.6,
        p85: 17.1,
        p95: 18.1,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      age: 27,
      m: 15.6037,
      s: 0.08446,
      percentiles: {
        p1: 13.0,
        p3: 13.4,
        p5: 13.7,
        p15: 14.3,
        p25: 14.8,
        p50: 15.6,
        p75: 16.5,
        p85: 17.1,
        p95: 18.0,
        p97: 18.4,
        p99: 19.2,
      },
    },
    {
      age: 28,
      m: 15.5777,
      s: 0.08444,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.6,
        p75: 16.5,
        p85: 17.0,
        p95: 18.0,
        p97: 18.4,
        p99: 19.2,
      },
    },
    {
      age: 29,
      m: 15.5523,
      s: 0.08443,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.6,
        p75: 16.5,
        p85: 17.0,
        p95: 18.0,
        p97: 18.4,
        p99: 19.2,
      },
    },
    {
      age: 30,
      m: 15.5276,
      s: 0.08444,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.5,
        p75: 16.5,
        p85: 17.0,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 31,
      m: 15.5034,
      s: 0.08448,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.2,
        p25: 14.7,
        p50: 15.5,
        p75: 16.4,
        p85: 17.0,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 32,
      m: 15.4798,
      s: 0.08455,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.5,
        p75: 16.4,
        p85: 16.9,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 33,
      m: 15.4572,
      s: 0.08467,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.5,
        p75: 16.4,
        p85: 16.9,
        p95: 17.9,
        p97: 18.3,
        p99: 19.0,
      },
    },
    {
      age: 34,
      m: 15.4356,
      s: 0.08484,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.4,
        p85: 16.9,
        p95: 17.9,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 35,
      m: 15.4155,
      s: 0.08506,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.9,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 36,
      m: 15.3968,
      s: 0.08535,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.5,
        p50: 15.4,
        p75: 16.3,
        p85: 16.9,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 37,
      m: 15.3796,
      s: 0.08569,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 38,
      m: 15.3638,
      s: 0.08609,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 39,
      m: 15.3493,
      s: 0.08654,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 40,
      m: 15.3358,
      s: 0.08704,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.4,
        p15: 14.0,
        p25: 14.5,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 41,
      m: 15.3233,
      s: 0.08757,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.5,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 42,
      m: 15.3116,
      s: 0.08813,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.0,
      },
    },
    {
      age: 43,
      m: 15.3007,
      s: 0.08872,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.1,
      },
    },
    {
      age: 44,
      m: 15.2905,
      s: 0.08931,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.2,
        p99: 19.1,
      },
    },
    {
      age: 45,
      m: 15.2814,
      s: 0.08991,
      percentiles: {
        p1: 12.5,
        p3: 13.0,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 46,
      m: 15.2732,
      s: 0.09051,
      percentiles: {
        p1: 12.5,
        p3: 13.0,
        p5: 13.2,
        p15: 13.9,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.8,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 47,
      m: 15.2661,
      s: 0.0911,
      percentiles: {
        p1: 12.5,
        p3: 13.0,
        p5: 13.2,
        p15: 13.9,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.9,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 48,
      m: 15.2602,
      s: 0.09168,
      percentiles: {
        p1: 12.5,
        p3: 12.9,
        p5: 13.2,
        p15: 13.9,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.9,
        p97: 18.3,
        p99: 19.2,
      },
    },
    {
      age: 49,
      m: 15.2556,
      s: 0.09227,
      percentiles: {
        p1: 12.5,
        p3: 12.9,
        p5: 13.2,
        p15: 13.9,
        p25: 14.4,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.9,
        p97: 18.3,
        p99: 19.2,
      },
    },
    {
      age: 50,
      m: 15.2523,
      s: 0.09286,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.2,
        p15: 13.9,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.9,
        p97: 18.3,
        p99: 19.2,
      },
    },
    {
      age: 51,
      m: 15.2503,
      s: 0.09345,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.2,
        p15: 13.9,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.8,
        p95: 17.9,
        p97: 18.4,
        p99: 19.2,
      },
    },
    {
      age: 52,
      m: 15.2496,
      s: 0.09403,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.9,
        p25: 14.3,
        p50: 15.2,
        p75: 16.3,
        p85: 16.9,
        p95: 17.9,
        p97: 18.4,
        p99: 19.3,
      },
    },
    {
      age: 53,
      m: 15.2502,
      s: 0.0946,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.9,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 17.9,
        p97: 18.4,
        p99: 19.3,
      },
    },
    {
      age: 54,
      m: 15.2519,
      s: 0.09515,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.9,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.0,
        p97: 18.4,
        p99: 19.3,
      },
    },
    {
      age: 55,
      m: 15.2544,
      s: 0.09568,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.9,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.0,
        p97: 18.4,
        p99: 19.4,
      },
    },
    {
      age: 56,
      m: 15.2575,
      s: 0.09618,
      percentiles: {
        p1: 12.4,
        p3: 12.8,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.0,
        p97: 18.5,
        p99: 19.4,
      },
    },
    {
      age: 57,
      m: 15.2612,
      s: 0.09665,
      percentiles: {
        p1: 12.4,
        p3: 12.8,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.0,
        p97: 18.5,
        p99: 19.4,
      },
    },
    {
      age: 58,
      m: 15.2653,
      s: 0.09709,
      percentiles: {
        p1: 12.3,
        p3: 12.8,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.0,
        p97: 18.5,
        p99: 19.4,
      },
    },
    {
      age: 59,
      m: 15.2698,
      s: 0.0975,
      percentiles: {
        p1: 12.3,
        p3: 12.8,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 16.9,
        p95: 18.1,
        p97: 18.5,
        p99: 19.5,
      },
    },
    {
      age: 60,
      m: 15.2747,
      s: 0.09789,
      percentiles: {
        p1: 12.3,
        p3: 12.8,
        p5: 13.1,
        p15: 13.8,
        p25: 14.3,
        p50: 15.3,
        p75: 16.3,
        p85: 17.0,
        p95: 18.1,
        p97: 18.6,
        p99: 19.5,
      },
    },
  ],
};
